const dangerLevels = {
  0: {
    rank: 0,
    name: 'troublesome',
    title: 'Troublesome',
  },
  1:{
    rank: 1,
    name: 'dangerous',
    title: 'Dangerous',
  },
  2:{
    rank: 2,
    name: 'formidable',
    title: 'Formidable',
  },
  3:{
    rank: 3,
    name: 'extreme',
    title: 'Extreme',
  },
  4:{
    rank: 4,
    name: 'epic',
    title: 'Epic',
  },
};

export default { dangerLevels };
